var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.alert.isEnabled)?_c('b-notification',{attrs:{"active":_vm.isActive,"type":_vm.alert.type},on:{"close":function($event){_vm.isActive = false}}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.alert.message)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }